module.exports = __webpack_public_path__ + "static/media/dog8.ff7fab41.jpeg";